module.exports = __webpack_public_path__ + "img/idata-alt.5fb7a382.svg";